import { Box, Paragraph, TextButton } from '@zillow/constellation-10';
import { EXPERIAN_DISPUTE_URL, EXPERIAN_NOTICE_TO_USERS_URL } from '@zg-rentals/applications-utils';
import { type EmitMetric, UserType } from '../../models/report-models';

interface CreditReportFooterProps {
  userType?: UserType;
  emitMetric: EmitMetric;
}

export function CreditReportFooter({ userType, emitMetric }: CreditReportFooterProps) {
  return (
    <>
      <TextButton asChild>
        <a href={EXPERIAN_NOTICE_TO_USERS_URL} rel="noreferrer" target="_blank">
          Notice to users
        </a>
      </TextButton>
      {userType === UserType.Renter && (
        <Box css={{ marginTop: 'xs' }}>
          <Paragraph textStyle="body-sm">Do you disagree with information in your credit report?</Paragraph>
          <TextButton
            asChild
            css={{ marginTop: 'xs' }}
            onClick={() => {
              emitMetric('FileADispute CreditReport');
            }}
          >
            <a href={EXPERIAN_DISPUTE_URL} rel="noreferrer" target="_blank">
              File a dispute with Experian
            </a>
          </TextButton>
        </Box>
      )}
    </>
  );
}
